import { render, staticRenderFns } from "./DataProcessorCandidatesDataForm.vue?vue&type=template&id=11e80980&scoped=true"
import script from "./DataProcessorCandidatesDataForm.vue?vue&type=script&lang=js"
export * from "./DataProcessorCandidatesDataForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e80980",
  null
  
)

export default component.exports